import { Controller, FieldPath, FieldValues, UseFormReturn } from "react-hook-form"
import { Flex } from "../../../../../components/flex/Flex"
import { theme } from "../../../../../styles/stitches.config"
import { FormItem, FormLabel } from "../components/Form"
import { FormInput } from "../components/Input"
import { getFormError, getFormSuccess } from "../../../../../utils/form"

type Props<FormValues extends FieldValues> = {
  form: UseFormReturn<FormValues>
  prefixFieldName: FieldPath<FormValues>
  numberFieldName: FieldPath<FormValues>
  bankCodeFieldName: FieldPath<FormValues>
}

export function BankAccountInputBlock<FormValues extends FieldValues>(props: Props<FormValues>) {
  const { form, bankCodeFieldName, numberFieldName, prefixFieldName } = props
  return (
    <Flex wrap="wrap" css={{ gap: theme.space.s4, "@sm": { flexWrap: "nowrap" } }}>
      <Controller
        control={form.control}
        name={prefixFieldName}
        render={({ field }) => (
          <FormItem css={{ width: "100%", "@sm": { width: "25%" } }}>
            <FormLabel>Předčíslí účtu</FormLabel>
            <FormInput
              id={prefixFieldName}
              type="text"
              placeholder="000000"
              {...field}
              error={getFormError({ form, name: prefixFieldName })}
              success={getFormSuccess({ form, name: prefixFieldName })}
            />
          </FormItem>
        )}
      />

      <Controller
        control={form.control}
        name={numberFieldName}
        render={({ field }) => (
          <FormItem css={{ width: "100%", "@sm": { width: "80%" } }}>
            <FormLabel>Číslo účtu</FormLabel>
            <FormInput
              id={numberFieldName}
              type="text"
              placeholder="0000000000"
              {...field}
              error={getFormError({ form, name: numberFieldName })}
              success={getFormSuccess({ form, name: numberFieldName })}
            />
          </FormItem>
        )}
      />

      <Controller
        control={form.control}
        name={bankCodeFieldName}
        render={({ field }) => (
          <FormItem css={{ width: "100%", "@sm": { width: "25%" } }}>
            <FormLabel>Kód banky</FormLabel>
            <FormInput
              id={bankCodeFieldName}
              type="text"
              placeholder="0000"
              {...field}
              error={getFormError({ form, name: bankCodeFieldName })}
              success={getFormSuccess({ form, name: bankCodeFieldName })}
            />
          </FormItem>
        )}
      />
    </Flex>
  )
}
